import React from "react";
import { Dialog, Button } from "@mui/material";
import { Translate } from "orion-components/i18n";
import { evacuationService } from "client-app-core";
import { simpleUnsub } from "orion-components/ContextualData/contextStreaming";
import { useDispatch, useSelector } from "react-redux";
import { resetEvacuation } from "../../../Services/EvacuationAccountabilityService/actions";

const ResetEvacuationDialog = ({ confirmReset, procedureId, setConfirmReset, setEvacuationStarted }) => {
	const subscriptionChannel = useSelector((state) => state?.evacuationAccountability?.subscriptionChannel) ?? null;

	const dispatch = useDispatch();
	return (
		<Dialog open={confirmReset} PaperProps={{ className: "reset-evacuation-dialog" }} data-testid="orion-components-shared-components-evacuation-accountability-components-reset-evacuation-dialog-dialog">
			<div className="section1" data-testid="orion-components-shared-components-evacuation-accountability-components-reset-evacuation-dialog-div">
				<div className="section1Child1" data-testid="orion-components-shared-components-evacuation-accountability-components-reset-evacuation-dialog-div-2">
					<div className="section1Child2" data-testid="orion-components-shared-components-evacuation-accountability-components-reset-evacuation-dialog-div-3">
						<div className="section1Child3" data-testid="orion-components-shared-components-evacuation-accountability-components-reset-evacuation-dialog-div-4">
							<Translate value="global.sharedComponents.evacuationAccountability.components.resetEvacuationDialog.confirmResetTitle" />
						</div>
						<div className="section1Child4" data-testid="orion-components-shared-components-evacuation-accountability-components-reset-evacuation-dialog-div-5">
							<Translate value="global.sharedComponents.evacuationAccountability.components.resetEvacuationDialog.confirmResetMsg" />
						</div>
					</div>

					<div
						className="section2"
						//  style={styles.section2} data-testid="orion-components-shared-components-evacuation-accountability-components-reset-evacuation-dialog-div-6"
					>
						<Button
							className="section2Child1"
							// style={styles.section2Child1}
							onClick={() => setConfirmReset(false)} data-testid="orion-components-shared-components-evacuation-accountability-components-reset-evacuation-dialog-button"
						>
							<Translate value="global.sharedComponents.evacuationAccountability.components.resetEvacuationDialog.cancel" />
						</Button>
						<Button
							className="section2Child2"
							// style={styles.section2Child2}
							onClick={() => {
								evacuationService.resetProcedure(procedureId, (err, result) => {
									if (err) {
										console.error("Failed to reset evacuation Procedure:", err);
										return;
									}

									if (result?.success) {
										if (subscriptionChannel) simpleUnsub(subscriptionChannel);
										setConfirmReset(false);
										setEvacuationStarted(false);
										dispatch(resetEvacuation());
									}
								});
							}} data-testid="orion-components-shared-components-evacuation-accountability-components-reset-evacuation-dialog-button-2"
						>
							<Translate value="global.sharedComponents.evacuationAccountability.components.resetEvacuationDialog.resetConfirm" />
						</Button>
					</div>
				</div>
			</div>
		</Dialog>
	);
};

export default ResetEvacuationDialog;
